import Box from "@mui/material/Box";
import TransparentButton from "../TransparentButton/TransparentButton";
import {useTheme} from "../../../contexts/theme";
import StyledDropdown from "../StyledDropdown/StyledDropdown";
import { useMediaQuery, useTheme as useMUITheme} from '@mui/material';

interface TransparentButtonSelectionProps{
    options: any[];
    labelField?: string;
    valueField?: string
    onChange: (competition: string) => void;
    value: string;
    needButtonBackground?: boolean;
}

const TransparentButtonSelection: React.FC<TransparentButtonSelectionProps> = ({needButtonBackground, labelField, valueField, options, onChange, value}) => {
    const theme = useTheme();
    const MUITheme = useMUITheme();
    const isSmallScreen = useMediaQuery(MUITheme.breakpoints.down('md'));

    return (
      <Box>
          {options.length <= 5 && !isSmallScreen &&
              <Box display='flex' gap={theme.spacing.md} width={'100%'}>
                  {options.map((competition, competitionIndex) => {
                      return (
                          <TransparentButton
                              selected={competition === value}
                              text={labelField ? competition[labelField] : competition}
                              onClick={() => onChange(valueField ? competition[valueField] : competition)}
                              key={"competitionSelectionButton" + competitionIndex}
                              needBackground={needButtonBackground}
                          />
                      )
                  })}
              </Box>
          }
          {/*(options.length >= 6  || isSmallScreen) &&
              <Box display='flex' width={'100%'} sx={{marginTop: theme.spacing.md}}>
                  <StyledDropdown
                      options={options}
                      label='Competitions'
                      value={value}
                      id='competionsDropdown'
                      onChange={(e) => onChange(e.target.value)}
                  />
              </Box>
          */}

      </Box>
    );
}

export default TransparentButtonSelection;